import { useEffect, useState } from 'react'

import { analyticsConfig } from '@/config/analytics.config'
import {
  ANALYTICS_CONSENT_CHANGED_EVENT,
  loadStoredConsent,
} from '@/lib/consent-storage'

function analyticsGranted(): boolean {
  return Boolean(loadStoredConsent()?.analytics)
}

export function GoogleAnalyticsLoader() {
  const measurementId = analyticsConfig.measurementId
  const [enabled, setEnabled] = useState(
    () => measurementId !== '' && analyticsGranted()
  )

  useEffect(() => {
    if (!measurementId) return

    const onConsentChanged = () => {
      setEnabled(analyticsGranted())
    }

    window.addEventListener(ANALYTICS_CONSENT_CHANGED_EVENT, onConsentChanged)
    return () =>
      window.removeEventListener(ANALYTICS_CONSENT_CHANGED_EVENT, onConsentChanged)
  }, [measurementId])

  useEffect(() => {
    if (!enabled || !measurementId) return

    const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
    if (document.querySelector(`script[src="${scriptSrc}"]`)) return

    const gtagScript = document.createElement('script')
    gtagScript.async = true
    gtagScript.src = scriptSrc
    document.head.appendChild(gtagScript)

    window.dataLayer = window.dataLayer || []
    window.gtag =
      window.gtag ||
      function gtag(...args: unknown[]) {
        window.dataLayer?.push(args)
      }
    window.gtag('js', new Date())
    window.gtag('config', measurementId)
  }, [enabled, measurementId])

  return null
}
